module.exports = __webpack_public_path__ + "img/logo4.dc45944f.png";